import type { Branded } from "@@/utilities/branded";
import { z } from "zod";

type Timezone = Branded<string, "Timezone">;

const EuropeStockholm = "Europe/Stockholm" as Timezone;
const EuropeOslo = "Europe/Oslo" as Timezone;
const EuropeCopenhagen = "Europe/Copenhagen" as Timezone;
const EuropeBerlin = "Europe/Berlin" as Timezone;
const EuropeLondon = "Europe/London" as Timezone;
const EuropeHelsinki = "Europe/Helsinki" as Timezone;
const UTC = "UTC" as Timezone;
const GMT = "GMT" as Timezone;

const timezoneZodType = z.custom<Timezone>(
    value => typeof value === "string" && value.length > 0,
);
z.string().transform<Timezone>(v => v as Timezone);

const tz = {
    EuropeStockholm,
    EuropeOslo,
    EuropeCopenhagen,
    EuropeBerlin,
    EuropeLondon,
    EuropeHelsinki,
    UTC,
    GMT,
};

export { timezoneZodType, tz };
export type { Timezone };
